var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-new-album"},[_c('div',{staticClass:"name-container"},[_c('div',[_vm._v(" Create new album: ")]),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name || 'Untitled')+" ")]),_c('div',[_vm._v(" … ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }